import { motion, useReducedMotion } from "framer-motion";

const ease = [0.22, 1, 0.36, 1];

// Section scroll reveal — gentle upward fade.
export function Reveal({ children, delay = 0, y = 28, className = "", as = "div" }) {
  const reduce = useReducedMotion();
  const M = motion[as] || motion.div;
  return (
    <M
      className={className}
      initial={reduce ? { opacity: 0 } : { opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-10% 0px -10% 0px" }}
      transition={{ duration: 1, ease, delay }}
    >
      {children}
    </M>
  );
}

// Masked line-by-line reveal for editorial headlines.
export function MaskLines({ lines, className = "", lineClassName = "", stagger = 0.12, delay = 0.15 }) {
  const reduce = useReducedMotion();
  return (
    <span className={className} aria-label={lines.join(" ")}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden">
          <motion.span
            className={`block ${lineClassName}`}
            initial={reduce ? { opacity: 0 } : { y: "110%" }}
            animate={reduce ? { opacity: 1 } : { y: "0%" }}
            transition={{ duration: 1.05, ease, delay: delay + i * stagger }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
}

// Slow image reveal — robust: image always renders, a Petal panel wipes away.
export function ImageReveal({ src, alt, className = "", imgClassName = "" }) {
  const reduce = useReducedMotion();
  return (
    <div className={`relative overflow-hidden ${className}`}>
      <img src={src} alt={alt} loading="lazy" className={`h-full w-full object-cover ${imgClassName}`} />
      {!reduce && (
        <motion.div
          className="absolute inset-0 bg-petal"
          initial={{ scaleY: 1 }}
          whileInView={{ scaleY: 0 }}
          viewport={{ once: true, margin: "-8%" }}
          transition={{ duration: 1.1, ease }}
          style={{ transformOrigin: "top" }}
        />
      )}
    </div>
  );
}
